module.exports = __webpack_public_path__ + "img/user.4e7d8f63.png";